export const getToken = () => {
  return localStorage.getItem('token');
};

export const setToken = (token) => {
  localStorage.setItem('token', token);
  // Dispatch custom event for same-tab listeners
  window.dispatchEvent(new Event('authChange'));
};

export const removeToken = () => {
  localStorage.removeItem('token');
  localStorage.removeItem('user');
  // Dispatch custom event for same-tab listeners
  window.dispatchEvent(new Event('authChange'));
};

export const getUser = () => {
  const user = localStorage.getItem('user');
  return user ? JSON.parse(user) : null;
};

export const setUser = (user) => {
  localStorage.setItem('user', JSON.stringify(user));
  // Dispatch custom event for same-tab listeners
  window.dispatchEvent(new Event('authChange'));
};

export const isAuthenticated = () => {
  return !!getToken();
};

export const isTeacher = () => {
  const user = getUser();
  return user && user.role === 'teacher';
};

export const isStudent = () => {
  const user = getUser();
  return user && user.role === 'student';
};

export const isAdmin = () => {
  const user = getUser();
  return user && user.role === 'admin';
};

export const isSeller = () => {
  const user = getUser();
  return user && user.role === 'seller';
};